import { Country } from 'country-state-city';
import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useDispatch, useSelector } from 'react-redux';
import { closeUserDetailsModal } from '../../redux/features/modalSlice';
const UserDetail = () => {
  const dispatch = useDispatch();
  const { userDetailsModal } = useSelector(({ modal }) => modal);

  const [presentCountry, setPresentCountry] = useState({});

  const handleClose = () => {
    dispatch(
      closeUserDetailsModal({
        userModalOpen: false,
        userModalData: {},
      }),
    );
  };

  useEffect(() => {
    if (userDetailsModal?.userModalData?.country) {
      const defaultCountry = Country.getCountryByCode(
        userDetailsModal?.userModalData?.country,
      );
      setPresentCountry(defaultCountry);
    }
  }, [userDetailsModal]);

  return (
    <>
      <Modal
        size="md"
        centered
        show={userDetailsModal?.userModalOpen}
        onHide={() => handleClose()}
        keyboard={false}
        backdrop="static"
      >
        <div className="modal-header">
          <h5 className="modal-title ">User Details</h5>
        </div>
        <div className="modal-body user-detail-modal">
          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label className="labelMove">Name:</label>
                <small>
                  {!userDetailsModal?.userModalData?.firstname
                    ? '---'
                    : ` ${userDetailsModal?.userModalData?.firstname || ''} ${
                        userDetailsModal?.userModalData?.lastname || ''
                      }
                 `}
                </small>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label className="labelMove">Email:</label>
                <small>
                  {userDetailsModal?.userModalData?.email
                    ? userDetailsModal?.userModalData?.email
                    : 'NA'}
                </small>
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group">
                <label className="labelMove">Phone:</label>
                <small>
                  {userDetailsModal?.userModalData?.phone
                    ? userDetailsModal?.userModalData?.phone
                    : 'NA'}
                </small>
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group">
                <label className="labelMove">Country:</label>
                <small>{presentCountry ? presentCountry?.name : 'NA'}</small>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label className="labelMove">Status:</label>
                <small>
                  {userDetailsModal?.userModalData?.status
                    ? userDetailsModal?.userModalData?.status
                    : 'NA'}
                </small>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label className="labelMove">Currency:</label>
                <small>
                  {userDetailsModal?.userModalData?.currency
                    ? userDetailsModal?.userModalData?.currency
                    : 'NA'}
                </small>
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group">
                <label className="labelMove">Credit:</label>
                <small>
                  {userDetailsModal?.userModalData?.credit
                    ? userDetailsModal?.userModalData?.credit
                    : 'NA'}
                </small>
              </div>
            </div>

            <div className="col-md-12">
              <h5 className="mb-4">User settings</h5>

              <Row>
                <Col>
                  <div className="form-group input_control input_control--gap">
                    <div className="w-100">
                      <label className=" font-weight-bold d-flex disable">
                        <input
                          type="checkbox"
                          name="push_notification"
                          checked={
                            userDetailsModal?.userModalData?.settings
                              ?.push_notification
                          }
                          disabled={true}
                        />
                        &nbsp; Push notification
                      </label>
                    </div>
                  </div>
                </Col>
                <Col>
                  <div className="form-group input_control input_control--gap">
                    <div className="w-100">
                      <label className=" font-weight-bold d-flex disable">
                        <input
                          type="checkbox"
                          name="email_notification"
                          checked={
                            userDetailsModal?.userModalData?.settings
                              ?.email_notification
                          }
                          disabled={true}
                        />
                        &nbsp; Email notification
                      </label>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="form-group input_control input_control--gap">
                    <div className="w-100">
                      <label className=" font-weight-bold d-flex disable">
                        <input
                          type="checkbox"
                          name="sms_notification"
                          checked={
                            userDetailsModal?.userModalData?.settings
                              ?.sms_notification
                          }
                          disabled={true}
                        />
                        &nbsp; Sms notification
                      </label>
                    </div>
                  </div>
                </Col>
                <Col>
                  <div className="form-group input_control input_control--gap">
                    <div className="w-100">
                      <label className=" font-weight-bold d-flex disable">
                        <input
                          type="checkbox"
                          name="auto_topup"
                          checked={
                            userDetailsModal?.userModalData?.settings
                              ?.auto_topup
                          }
                          disabled={true}
                        />
                        &nbsp; Auto topup
                      </label>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>

            <div className="col-md-12 text-right">
              <button
                type="button"
                onClick={() => handleClose()}
                className="btn btn-default"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default UserDetail;
